<div class="w-full rounded-2xl bg-white p-5 shadow-xl sm:p-6">
  <div class="flex items-start justify-between gap-4">
    <div class="min-w-0">
      <h2 class="text-lg font-semibold text-slate-950">New group</h2>
      <p class="mt-1 text-sm text-slate-500">
        Create a contact group for this workspace.
      </p>
    </div>
    <button
      type="button"
      class="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg text-lg text-slate-500 transition hover:bg-slate-100"
      aria-label="Close"
      (click)="close()">
      ×
    </button>
  </div>

  <div class="mt-5 flex flex-col gap-4">
    <lib-signal-text-field
      label="Name"
      placeholder="e.g. Marketing Team"
      [value]="name()"
      [debounceValueChange]="false"
      (valueChange)="name.set($event)" />

    <lib-signal-textarea
      label="Description"
      placeholder="Optional description"
      [value]="description()"
      [debounceValueChange]="false"
      (valueChange)="description.set($event)" />

    <div class="mt-2 flex flex-col-reverse gap-2 sm:flex-row sm:justify-end">
      <lib-signal-button
        appearance="outline"
        [disabled]="createState.loading()"
        (clicked)="close()">
        Cancel
      </lib-signal-button>
      <lib-signal-button
        [loading]="createState.loading()"
        [disabled]="createState.loading()"
        (clicked)="onSave()">
        Save
      </lib-signal-button>
    </div>
  </div>
</div>
